export default {
    auth: {
        signUp: {
            title: "Crear una cuenta",
            email: "Correo electrónico",
            password: "Contraseña",
            confirmPassword: "Confirmar contraseña",
            submit: "Registrarse",
            loading: "Registrando...",
            alreadyHaveAccount: "¿Ya tienes una cuenta? Inicia sesión",
            confirmationSent: "Se ha enviado un correo de confirmación",
        },
        login: {
            title: "Iniciar sesión",
            email: "Correo electrónico",
            password: "Contraseña",
            submit: "Iniciar sesión",
            loading: "Iniciando sesión...",
            forgotPassword: "¿Olvidaste tu contraseña?",
            noAccount: "¿No tienes cuenta? Créala aquí",
            language: "Idioma",
        },
        forgotPassword: {
            title: "Contraseña olvidada",
            email: "Correo electrónico",
            submit: "Enviar enlace de recuperación",
            loading: "Enviando...",
            backToLogin: "Volver al inicio de sesión",
            successMessage: "Se ha enviado un correo de recuperación",
        },
        resetPassword: {
            title: "Restablecer contraseña",
            password: "Nueva contraseña",
            confirmPassword: "Confirmar nueva contraseña",
            submit: "Restablecer contraseña",
            loading: "Restableciendo...",
            success:
                "¡Tu contraseña se ha restablecido con éxito! Ahora puedes iniciar sesión.",
        },
        confirmEmail: {
            title: "Confirmación de correo requerida",
            verifying: "Verificando...",
            invalidLink: "Enlace inválido",
            backToLogin: "Volver al inicio de sesión",
            successMessage: "Tu cuenta ha sido activada",
        },
        errors: {
            generic: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
            invalidEmail: "Correo electrónico inválido",
            passwordRequired: "La contraseña es obligatoria",
            passwordLength: "La contraseña debe tener al menos 8 caracteres",
            passwordFormat:
                "La contraseña debe contener al menos una mayúscula, una minúscula y un número",
            passwordMatch: "Las contraseñas no coinciden",
            noAdminAccess: "Acceso no autorizado",
            invalidToken: "Enlace inválido o expirado",
            samePassword:
                "La nueva contraseña debe ser diferente a la anterior",
        },
    },
};
